import React from "react";
import SkillItem from "./SkillItem";

const skillData = [
  {
    id: 1,
    title: "HTML, CSS",
    percentage: "100%",
  },
  {
    id: 2,
    title: "C/C++",
    percentage: "100%",
  },
  {
    id: 3,
    title: "TailwindCSS",
    percentage: "90%",
  },
  {
    id: 4,
    title: "JavaScript/typeScript",
    percentage: "90%",
  },
  {
    id: 5,
    title: "ReactJS",
    percentage: "90%",
  },
  {
    id: 6,
    title: "NextJS",
    percentage: "80%",
  },
  {
    id: 7,
    title: "PostgreSQL",
    percentage: "85%",
  },
  {
    id: 8,
    title: "SQLite",
    percentage: "80%",
  },
  {
    id: 9,
    title: "Redis",
    percentage: "75%",
  },
  {
    id: 10,
    title: "Docker",
    percentage: "75%",
  },
];

const Skills = () => {
  return (
    <div className="py-4">
      <div className="flex flex-wrap">
        <div className="w-full">
          <div className="md:mx-4">
            <h3 className="text-2xl text-gray-800 font-bold mb-4">Skills</h3>
          </div>
        </div>
        {skillData.map((skill, id) => (
          <SkillItem skill={skill} key={id} />
        ))}
      </div>
    </div>
  );
};

export default Skills;
